<template>
  <div class="p-fa-home">
    <Navigation> </Navigation>
    <div class='privacy-header'>
      <div class='privacy-header-container'>
        <h2>Kebijakan Privasi</h2>
      </div>
    </div>
    <Container>
      <div class="row privacy-row">
        <div class="privacy-content">
          <ol type="A" class="privacy-list">
            <li>
              <strong>Umum</strong>
              <br />
              <br />
              <ol type="a">
                <li>
                  Sequis adalah identitas utama perusahaan yang menaungi PT Asuransi Jiwa Sequis
                  Life (&quot;Sequis Life&quot;) dan anak perusahaanya, yang terdiri dari PT
                  Asuransi Jiwa Sequis Financial (&quot;Sequis Financial&quot;) dan PT Sequis Aset
                  Manajemen (&quot;PT Sequis Aset Manajemen&quot;)
                </li>
                <br />
                <li>
                  Sequis berkomitmen untuk tetap menjaga dan menghormati privasi Anda dan menghargai
                  kepercayaan yang Anda berikan. Dengan Anda mengunjungi dan/atau menggunakan
                  aplikasi dan/atau situs Aplikasi Sequis ini, Anda telah menyepakati persyaratan
                  yang tercantum didalam Kebijakan Privasi ini. Mohon untuk dapat membaca kebijakan
                  secara seksama dan teliti.
                  <br />
                </li>
              </ol>
            </li>
            <br />
            <br />
            <li>
              <strong>Pengumpulan Informasi Pribadi</strong>
              <br />
              <br />
              <ol type="a">
                <li>
                  Sequis menerima dan mengumpulkan informasi dengan tujuan memberikan pelayanan yang
                  lebih baik kepada semua Nasabah dan/atau Pengguna. Informasi yang diterima dan
                  dikumpulkan oleh Sequis dari Nasabah dan/atau Pengguna melalui aplikasi dan/atau
                  situs Aplikasi Sequis antara lain adalah sebagai berikut:
                  <br />
                  <br />
                  <ol type="i">
                    <li>
                      Informasi pribadi seperti nomor telepon, email, alamat, nomor kartu kredit.
                    </li>
                    <br />
                    <li>Informasi lokasi.</li>
                  </ol>
                </li>
                <br />
                <li>
                  Informasi pribadi Pengguna Aplikasi Sequis yang diterima dan dikumpulkan oleh
                  Sequi dapat dikirim dan diberikan kepada pihak ketiga yang menyediakan dan
                  mendukung Sequis dalam memberikan layanan. Sequis juga akan membagikan informasi
                  Pengguna saat diminta oleh pihak yang berwenang sesuai dengan peraturan yang
                  berlaku.
                  <br />
                </li>
              </ol>
            </li>
            <br />
            <br />
            <li>
              <strong>Akses dan Pembaruan Informasi Pribadi</strong>
              <br />
              <br />
              <ol type="a">
                <li>
                  Sequis bertujuan untuk memberikan akses kepada Pengguna untuk mengetahui informasi
                  pribadi dan memberikan cara untuk memperbaharui informasi tersebut.
                </li>
                <br />
                <li>
                  Sequis juga bertujuan untuk menjaga tingkat layanan dengan melindungi informasi
                  dari kehancuran/penghilangan yang tidak disengaja atau berbahaya. Oleh karena itu,
                  setelah Anda menghapus informasi dari aplikasi dan/atau situs Aplikasi Sequis,
                  Sequis mungkin tidak dengan segera menghapus salinan dari server aktif dan sistem
                  cadangan.
                  <br />
                </li>
                <br />
                <li>
                  Dengan memberikan data pribadi Anda kepada kami, 
                  Anda setuju jika Sequis dapat menyimpan informasi pribadi Anda selama diperlukan untuk memenuhi tujuan pengumpulannya sesuai dengan ketentuan hukum dan peraturan yang berlaku serta kebijakan internal Sequis yang berlaku. 
                  Anda dapat meminta kami untuk menghapus informasi pribadi Anda jika informasi tersebut tidak lagi diperlukan sebagaimana tujuan di atas atau jika tidak ada dasar hukum lain untuk pemrosesan melalui email ke 
                  <b> care@sequislife.com</b>
                  <br />
                </li>
              </ol>
            </li>
            <br />
            <br />
            <li>
              <strong>Keamanan</strong>
              <br />
              <br />
              Sequis akan melindungi informasi pribadi Anda dengan perlindungan keamanan yang sesuai
              dengan tujuan untuk melindungi informasi pribadi Anda dari akses oleh pihak yang tidak
              berwenang dan bentuk penyalahgunaan lainnya.
              <br />
            </li>
            <br />
            <br />
            <li>
              <strong>Penggunaan Cookie</strong>
              <br />
              <br />
              <ol type="a">
                <li>
                  Cookie adalah data kecil yang dikirim ke browser Anda. Cookie dapat digunakan oleh
                  aplikasi dan/atau situs untuk menyimpan informasi atau mengingat preferensi Anda.
                </li>
                <br />
                <li>
                  Sequis menggunakan cookie untuk beberapa tujuan, antara lain untuk mengingat
                  preferensi penelusuran aman, membantu penggunaan aplikasi dan/atau situs dan
                  melindungi data Anda.
                  <br />
                </li>
              </ol>
            </li>
            <br />
            <br />
            <li>
              <strong>Perubahan atas Kebijakan Privasi</strong>
              <br />
              <br />
              <ol type="a">
                <li>
                  Sequis memiliki hak untuk mengubah Kebijakan Privasi ini tanpa pemberitahuan
                  sebelumnya. Perubahan akan berlaku efektif pada saat Sequis mengumumkan Kebijakan
                  Privasi pada aplikasi dan/atau situs Sequis.
                </li>
                <br />
                <li>
                  Dengan tetap menggunakan layanan setelah perubahan-perubahan tersebut, Anda telah
                  dianggap setuju atas segala perubahan.
                </li>
                <br />
                <li>
                  Apabila Anda tidak setuju pada ketentuan dari Kebijakan Privasi ini, seluruhnya
                  maupun sebagian, Anda dapat memilih untuk tidak menggunakan aplikasi dan/atau
                  situs ini.
                </li>
                <br />
                <li>
                  Kebijakan privasi ini telah direvisi dan mulai berlaku sejak Agustus 2020.
                  <br />
                </li>
              </ol>
            </li>
            <br />
            <br />
            <li>
              <strong>Hubungi Kami</strong>
              <br />
              <br />
              Apabila Anda memiliki pertanyaan sehubungan Kebijakan Privasi ini, silahkan hubungi
              kami melalui bagian &quot;Bantuan&quot; sebagaimana tercantum di Aplikasi Sequis.
            </li>
          </ol>
        </div>
      </div>
    </Container>
    <div class="c-footer">
      <div class="col-sm-12" style="text-align: center; padding: 0 10%;">
        <div>PT Asuransi Jiwa Sequis Life berizin dan diawasi oleh Otoritas Jasa Keuangan</div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '../components/Navigation';
import Container from '../components/Container';

export default {
  name: 'Policy',
  components: {
    Navigation,
    Container,
  },
};
</script>
